import '../../styles/CodeOfConduct/coc.scss'

const CodeofConduct = () => {

  return (
    <div className="coc">
      <p className='coc__para'>DevHub is a developer-friendly community with a motto of <span className='coc__para--pink'>" Together We Grow "</span>.</p>
      <p className='coc__para'>Our aim is to educate more people about the latest technologies and opportunities. We will help you in your journey and will support you whenever you need any help.
        We at DevHub provide students with learning opportunities, resources, and career mentorship. If you are someone who wants to be industry ready, you are at the right place.</p>


      <h1 className='coc__heading'>CODE OF CONDUCT</h1>

      <p className='coc__para'>It is essential for all participants in an event, including attendees, staff members, speakers, and organizers, to comply with a code of conduct in order to create
        an environment that is secure, polite, and welcoming to people of all backgrounds.</p>


      <div className='coc__group'>

        <h2 className='coc__group--heading'>What We Highly Encourage:</h2>


        <ol type="1" className='coc__group--list'>
          <li>
            <h3 className='coc__group--list-heading'>Be Respectful With All Members</h3>
            <p className='coc__group--list-para'>
              Be respectful to others. It helps us to create a positive and welcoming community environment. This way more folks will be encouraged to participate and contribute
              to the community. Disagreements happen and are normal, but making continuous, repetitive, or severe negative comments or circumventing a block or ban can cross the line
              into harassment and is not okay.
            </p>
          </li>

          <li>
            <h3 className='coc__group--list-heading'>
              Show Proferssioanlism

            </h3>
            <p className='coc__group--list-para'>
              Every member has self-respect and they deserve empathy. Pay attention actively and with the intention of understanding others' thoughts and feelings.
            </p>
          </li>

          <li>
            <h3 className='coc__group--list-heading'>
              Feedback
            </h3>
            <p className='coc__group--list-para'>
              As a respected community member, we expect you to give us or another member constructive feedback so that we can improve ourselves. Also, if someone gives you
              constructive feedback, accept it with an open heart and try to improve that.
            </p>
          </li>

          <li>
            <h3 className='coc__group--list-heading'>
              Be Friendly
            </h3>
            <p className='coc__group--list-para'>
              You should show some friendly and open nature that can be done by:
            </p>
            <ul className='coc__group--sublist'>
              <li>Making small talk and engaging in conversation with others.</li>
              <li>Listening actively and showing interest in what others have to say.</li>
              <li>Offering help or support when someone needs it.</li>
            </ul>
          </li>
        </ol>
      </div>



      <div className='coc__group'>

        <h2 className='coc__group--heading'>What We Highly Discourage:</h2>

        <ol type="1" className='coc__group--list'>
          <li>
            <h3 className='coc__group--list-heading'>Do Not Discuss Sensitive Topics</h3>
            <p className='coc__group--list-para'>This isn't a debating community, keep sensitive topics out of here and focus on the good stuff. No political issues or any sensitive should be discussed during
              the events or on our social platforms such as Whatsapp, Discord, etc.</p>
          </li>

          <li>
            <h3 className='coc__group--list-heading'>
              No Advertising
            </h3>
            <p className='coc__group--list-para'>
              Avoid any kind of advertisement in community groups or events. If you think that information can be important for the community member, make sure to verify with the
              Admins before sending.
            </p>
          </li>

          <li>
            <h3 className='coc__group--list-heading'>
              No NSFW content
            </h3>
            <p className='coc__group--list-para'>
              NSFW = Not Safe for Work. Anything involving gore or sexual content is not allowed. It is important to respect the feelings and sensitivities of others and to
              consider the impact of our actions on those around us.
            </p>
          </li>

          <li>
            <h3 className='coc__group--list-heading'>
              No spamming in Groups

            </h3>
            <p className='coc__group--list-para'>
              No spamming is allowed in community groups. Spamming includes, but is not limited to:
            </p>

            <ul className='coc__group--sublist'>
              <li>Sending repetitive or irrelevant messages</li>
              <li>Sending unsolicited advertising or promotional materials</li>
              <li>Sending mass messages to multiple people without their consent</li>
            </ul>
          </li>

          <li>
            <h3 className='coc__group--list-heading'>
              Do Not Share Any Pirated Content
            </h3>
            <p className='coc__group--list-para'>
              Do not distribute or offer access to any content that involves hacking, cracking, or the distribution of stolen products, pirated content, or accounts.
            </p>
          </li>

          <li>
            <h3 className='coc__group--list-heading'>
              Zero Tolerance Harassment Policy
            </h3>
            <p className='coc__group--list-para'>
              Our community is committed to creating a safe and inclusive environment for all members. We have a zero-tolerance policy on harassment of any kind, including but not limited to:

            </p>
            <ul className='coc__group--sublist'>
              <li>Stalking</li>
              <li>Threats</li>
              <li>Abusive Language</li>
              <li>Unwelcome sexual attention</li>
              <li>Inappropriate physical contact</li>
              <li>Harassing photography or recording</li>
            </ul>
          </li>
        </ol>
      </div>

      <div className='coc__group'>


        <h2 className='coc__group--heading'>
          Where To Report Any Issue Or Violation?
        </h2>
        <p className='coc__group--para'>
          If you become aware of a violation of the code of conduct either at an online event or in a personal event, you are strongly encouraged to report it to the Directors of our
          community or the Group Admins of any relevant groups. Please do not hesitate to reach out to us if you are experiencing harassment of any kind, if you become aware that
          another individual is being harassed, or if you have any other concerns.
          If you don’t feel comfortable going through one of the ways mentioned above, you can directly contact arfarooqix@gmail.com or abdul.Raheem@studentambassadors.com
        </p>

      </div>

      <div className='coc__group'>
        <h2 className='coc__group--heading'>
          How We Make Sure of Code of Conduct?
        </h2>

        <p className='coc__group--para'>
          We investigate and respond to any Event Community Guidelines and Anti-Harassment Policy violations under our zero-tolerance policy. We have a team for this which includes
          Campus authorities such as HOD and Usher Team who will look into the matter in a neutral manner and in-depth while considering all the aspects.
        </p>
        <p className='coc__group--para'>
          For any person found guilty of a violation of the code of conduct or any mishap, we will immediately take action against him including warning or expelling the offender from
          the community and we will also inform local authorities regarding the issue depending upon the nature of the issue.
        </p>
      </div>

    </div>
  );
};

export default CodeofConduct;